import { format } from 'url';
import type { NextRouter } from 'next/router';

export const getVariationFormattedLink = (sku: string | null, router: NextRouter): string => {
  if (sku) {
    return format({
      pathname: router.pathname,
      query: {
        ...router.query,
        sku,
      },
    });
  }
  return format({
    pathname: router.pathname,
    query: router.query,
  });
};
